import Logo from '@/components/Logo';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <Logo fontSize={40} />
        </div>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          <p className="text-sm text-gray-500 mb-6">Last updated: January 2025</p>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Overview</h2>
              <p>
                TrueUp is a bill-splitting application that helps groups divide shared expenses.
                This policy describes how we collect, use, and protect your information.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Information We Collect</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  <strong>Name:</strong> When joining an event, you provide a display name.
                  This is visible only to other participants in the same event.
                </li>
                <li>
                  <strong>Email Address:</strong> When you sign in with Google or Apple, we receive
                  your email address for account identification purposes.
                </li>
                <li>
                  <strong>User ID:</strong> We create a unique account identifier for each user
                  to manage your events and data.
                </li>
                <li>
                  <strong>Receipt Images:</strong> Event organizers may upload receipt images.
                  These images are processed using optical character recognition (OCR) and
                  artificial intelligence to extract item information.
                </li>
                <li>
                  <strong>Technical Information:</strong> We may collect technical data such as
                  IP addresses for service operation, security, and rate limiting purposes.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">How We Use Your Information</h2>
              <p>Your information is used to:</p>
              <ul className="list-disc list-inside space-y-1 mt-2">
                <li>Authenticate your account and maintain your session</li>
                <li>Provide and operate the bill-splitting service</li>
                <li>Process receipt images to extract item details</li>
                <li>Display participant information to other event members</li>
                <li>Maintain service security and prevent abuse</li>
              </ul>
              <p className="mt-2">
                We do not use your data for advertising, tracking, or profiling purposes.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Data Retention</h2>
              <p>
                Receipt images are automatically deleted within a short period after event completion.
                Users may delete their events at any time through the application.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Data Sharing</h2>
              <p>
                We do not sell your personal information. We do not share your data for
                advertising purposes. Your information is not used for AI model training.
              </p>
              <p className="mt-2">
                We may share data with service providers who assist in operating our service
                (such as cloud hosting and image processing), subject to confidentiality obligations.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Third-Party Services</h2>
              <p>
                The app may use third-party services for authentication (such as Google Sign-In),
                cloud storage, and image processing. These services have their own privacy policies.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Security</h2>
              <p>
                We implement reasonable security measures to protect your information.
                However, no method of transmission over the internet is completely secure.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. We encourage you to
                review this page periodically for any changes.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Contact</h2>
              <p>
                If you have questions about this privacy policy, please contact us through
                the application.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
